__turbopack_context__.v({
  "headerOne": "VGsKbq_headerOne",
  "headerThree": "VGsKbq_headerThree",
  "headerTwo": "VGsKbq_headerTwo",
  "list": "VGsKbq_list",
  "markdownWrapper": "VGsKbq_markdownWrapper",
  "orderedList": "VGsKbq_orderedList",
  "paragraph": "VGsKbq_paragraph",
  "unorderedList": "VGsKbq_unorderedList",
});
